// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__uqLaU","detailsBorder":"styles_detailsBorder__2QZne"};